import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setNavbarColor, setStatusbarColor } from "../featurs/homeSlice";

const useHandleIntersection = ({
  section1InView,
  section2InView,
  section3InView,
  section4InView,
  section5InView,
  section6InView,
  section7InView,
  sectionProductInView,
  sectionFrbInView,
  sectionTrustInView,
  sectionFooterInView,
}) => {
  const dispatch = useDispatch();
  const cache = useRef("#292929");
  // Track the nav color too: two sections can share a statusbar color but need
  // different nav themes (e.g. hero "transparent" and section4 "gray" are both
  // #292929), so keying the dedup only on statusbar could skip a needed repaint.
  const colorCache = useRef("transparent");

  useEffect(() => {
    let color = "";
    let statusbarColor = "";
    if (section1InView) {
      color = "transparent";
      statusbarColor = "#292929";
    } else if (section2InView) {
      color = "light";
      statusbarColor = "#ffffff";
    } else if (section4InView) {
      color = "gray";
      statusbarColor = "#292929";
    } else if (sectionProductInView) {
      color = "dark";
      statusbarColor = "#08080c";
    } else if (sectionFrbInView) {
      // Flat Rent Budapest — paper ground between the two dark product bands.
      color = "light";
      statusbarColor = "#faf7f2";
    } else if (section5InView) {
      color = "dark";
      statusbarColor = "#000000";
    } else if (section3InView) {
      // Approach — sits between Trust and NOTCH in page order; this chain's
      // priority must mirror section order (first match wins mid-transition).
      color = "light";
      statusbarColor = "#ffffff";
    } else if (section6InView) {
      color = "light";
      statusbarColor = "#ffffff";
    } else if (section7InView) {
      color = "light";
      statusbarColor = "#ffffff";
    } else if (sectionTrustInView) {
      color = "light";
      statusbarColor = "#f4f3f0";
    } else if (sectionFooterInView) {
      color = "dark";
      statusbarColor = "#0e0d12";
    } else {
      color = "light";
      statusbarColor = "#ffffff";
    }

    if (cache.current !== statusbarColor || colorCache.current !== color) {
      dispatch(setNavbarColor(color));
      dispatch(setStatusbarColor(statusbarColor));
      cache.current = statusbarColor;
      colorCache.current = color;
    }
  }, [
    dispatch,
    section1InView,
    section2InView,
    section3InView,
    section4InView,
    section5InView,
    section6InView,
    section7InView,
    sectionProductInView,
    sectionFrbInView,
    sectionTrustInView,
    sectionFooterInView,
  ]);
};

export { useHandleIntersection };
